import { createActionTypes } from "@helpers/redux-helpers";

export const getQrCodeTypes = createActionTypes("2fa/qr");

export const twoFactorsEnableTypes = createActionTypes("2fa/enable");

export const completeTwoFactorsTypes = createActionTypes("2fa/completeAuth");

export const disalbeTwoFactorsTypes = createActionTypes("2fa/disable");

export const twoFactorsTypes = createActionTypes("2fa");

export const twoFactorModalType = "2fa/enableModal";
